import React from "react";
import { Stack, TextField } from "@mui/material";

// comments: English only
export default function DateRange({ value, onChange, t }) {
  return (
    <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
      <TextField
        type="date"
        label={t("from") || "من"}
        value={value.from}
        onChange={(e) => onChange({ ...value, from: e.target.value })}
        size="small"
      />
      <TextField
        type="date"
        label={t("to") || "إلى"}
        value={value.to}
        onChange={(e) => onChange({ ...value, to: e.target.value })}
        size="small"
      />
    </Stack>
  );
}
